module.exports = Object.freeze({ ASCENDING: 'asc', DESCENDING: 'desc' })
